import * as moment from 'moment';

export class Discount {
  id: number;
  comment: string;
  till: any;
  disabled?: boolean;

  setFromApiModel(apiModel: any): this {
    this.id = apiModel.id;
    this.comment = apiModel.comment;
    this.till = moment(apiModel.till);
    return this;
  }
}
